import { IdentificationReqBody } from '@ytl/common-model';
import { axiosInstance } from './axiosInstance';

type GetIdentityJwtResp = {
  token: string;
};

export const gripResource = {
  async startIdentification(
    identificationReqBody: IdentificationReqBody,
  ): Promise<{ verificationLink: string | undefined }> {
    const res = await axiosInstance.post<{ verificationLink: string | undefined }>(
      '/api/grip/identification-start',
      identificationReqBody,
    );
    return res.data;
  },
  async getIdentity(externalId: string): Promise<string> {
    const res = await axiosInstance.get<GetIdentityJwtResp>(`/api/grip/get-identity/${encodeURIComponent(externalId)}`);
    return res.data.token;
  },
};
